export default class Stats {
  constructor() {
    this.unique = 0;
    this.count = 0;
    this.boost = 0;
    this.attack = { unique: 0, count: 0, value: 0, boost: 0 };
    this.defence = { unique: 0, count: 0, value: 0, boost: 0 };
    this.versatile = { unique: 0, count: 0, value: 0, boost: 0 };
    this.scheme = { unique: 0, count: 0, value: 0, boost: 0 };
  }

  get defense() {
    return this.defence;
  }

  update(card) {
    this.unique++;
    this.count += card.quantity;
    this.boost += card.boost;

    this[card.type].unique++;
    this[card.type].count += card.quantity;
    this[card.type].value += card.quantity * card.value;
    this[card.type].boost += card.quantity * card.boost;
  }

  add(stats) {
    const summedStats = new Stats();

    summedStats.unique = this.unique + stats.unique;
    summedStats.count = this.count + stats.count;
    summedStats.boost = this.boost + stats.boost;
    ["attack", "defence", "versatile", "scheme"].forEach(cardType => {
      ["unique", "count", "value", "boost"].forEach(dataType => {
        summedStats[cardType][dataType] =
          this[cardType][dataType] + stats[cardType][dataType];
      });
    });

    return summedStats;
  }

  get totalAttack() {
    return {
      unique: this.attack.unique + this.versatile.unique,
      count: this.attack.count + this.versatile.count,
      value: this.attack.value + this.versatile.value,
      boost: this.attack.boost + this.versatile.boost
    };
  }

  get totalDefence() {
    return {
      unique: this.defence.unique + this.versatile.unique,
      count: this.defence.count + this.versatile.count,
      value: this.defence.value + this.versatile.value,
      boost: this.defence.boost + this.versatile.boost
    };
  }
}
